import { CheckboxFilterComponent } from '@/shared/components/table/components/checkbox-filter/checkbox-filter.component';
import { PageDirection, TableDataSource } from "@/shared/components/table/table.model";
import { ClusterCollaboratorFragment, ClusterCollaboratorsGQL, Collaborator } from "@/core/graphql/graphql";
import { CollectionViewer } from "@angular/cdk/collections";
import { MatSort } from "@angular/material/sort";
import { FilterComponent } from "@/shared/components/table/components/filter/filter.component";
import { SearchbarComponent } from "@/shared/components/table/components/searchbar/searchbar.component";
import { BehaviorSubject, Observable } from "rxjs";
import { PaginatorComponent } from "@/shared/components/table/components/paginator/paginator.component";

export class ClusterCollaboratorsDatasource extends TableDataSource<Collaborator> {
  public paginator: PaginatorComponent;
  public searchbar: SearchbarComponent;
  public sort: MatSort;
  public filter: FilterComponent;
  private _collaboratorsSubject = new BehaviorSubject<ClusterCollaboratorFragment[]>([])

  public constructor(
    private readonly _clusterCollaboratorsGql: ClusterCollaboratorsGQL,
    private readonly _clusterId: number,
  ) {
    super();
  }

  public set checkboxFilter(component: CheckboxFilterComponent) {}

  public connect(collectionViewer: CollectionViewer): Observable<ClusterCollaboratorFragment[]> {
    return this._collaboratorsSubject.asObservable();
  }

  public disconnect(collectionViewer: CollectionViewer): void {
    this._collaboratorsSubject.complete();
  }

  public onPaginationChange(requestedChange: PageDirection): void {
  }

  public loadData(): void {
    this._clusterCollaboratorsGql.fetch({
      id: this._clusterId,
      meta: {
        pageSize: 10,
        pageCursor: undefined,
      },
    }).subscribe((x) => {
      this._collaboratorsSubject.next(x.data.cluster.collaborators.items);
    });
  }
}
